module.exports = __webpack_public_path__ + "static/media/icon_aam_active.7e0bbaa0.svg";